<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button></ion-back-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()" class="header--button-close">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>{{title}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <p>
    <i>Provider Site</i> is the centre where the {{clinician}} manages your program.
  </p>
  <p translate>
    Ask your {{clinician}} for this information
  </p>
</ion-content>
<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button color="primary" (click)="dismiss()">Close</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
